import * as React from 'react';
import { CanvasInnerDefault, CanvasOuterDefault, CanvasWrapper, LinkDefault, LinkWrapper, NodeDefault, NodeInnerDefault, NodeWrapper, PortDefault, PortsDefault, } from '../../';
export const FlowChart = (props) => {
    const [canvasSize, setCanvasSize] = React.useState({ width: 0, height: 0 });
    const { chart, callbacks: { onDragNode, onDragCanvas, onCanvasDrop, onLinkStart, onLinkMove, onLinkComplete, onLinkCancel, onPortPositionChange, onLinkMouseEnter, onLinkMouseLeave, onLinkClick, onCanvasClick, onDeleteKey, onNodeClick, onNodeSizeChange, }, Components: { CanvasOuter = CanvasOuterDefault, CanvasInner = CanvasInnerDefault, NodeInner = NodeInnerDefault, Ports = PortsDefault, Port = PortDefault, Node = NodeDefault, Link = LinkDefault, } = {}, config = {}, } = props;
    const { links, nodes, selected, hovered, offset } = chart;
    const canvasCallbacks = { onDragCanvas, onCanvasClick, onDeleteKey, onCanvasDrop };
    const linkCallbacks = { onLinkMouseEnter, onLinkMouseLeave, onLinkClick };
    const nodeCallbacks = { onDragNode, onNodeClick, onNodeSizeChange };
    const portCallbacks = { onPortPositionChange, onLinkStart, onLinkMove, onLinkComplete, onLinkCancel };
    let nodesInView = Object.keys(nodes);
    let linksInView = Object.keys(links);
    if (config.clip) {
        nodesInView = nodesInView.filter((nodeId) => {
            // TODO: define this in chart?
            const defaultNodeSize = { width: 500, height: 500 };
            const { x, y } = nodes[nodeId].position;
            const size = nodes[nodeId].size || defaultNodeSize;
            return x + offset.x + size.width > 0 && x + offset.x < canvasSize.width &&
                y + offset.y + size.height > 0 && y + offset.y < canvasSize.height;
        });
        linksInView = linksInView.filter((linkId) => {
            const from = links[linkId].from;
            const to = links[linkId].to;
            return (!to.nodeId ||
                nodesInView.indexOf(from.nodeId) !== -1 ||
                nodesInView.indexOf(to.nodeId) !== -1);
        });
    }
    return (React.createElement(CanvasWrapper, Object.assign({ config: config, position: chart.offset, ComponentInner: CanvasInner, ComponentOuter: CanvasOuter, onSizeChange: (width, height) => setCanvasSize({ width, height }) }, canvasCallbacks),
        linksInView.map((linkId) => {
            const isSelected = !config.readonly && selected.type === 'link' && selected.id === linkId;
            const isHovered = !config.readonly && hovered.type === 'link' && hovered.id === linkId;
            const fromNodeId = links[linkId].from.nodeId;
            const toNodeId = links[linkId].to.nodeId;
            return (React.createElement(LinkWrapper, Object.assign({ config: config, key: linkId, link: links[linkId], Component: Link, isSelected: isSelected, isHovered: isHovered, fromNode: nodes[fromNodeId], toNode: toNodeId ? nodes[toNodeId] : undefined }, linkCallbacks)));
        }),
        nodesInView.map((nodeId) => {
            const isSelected = selected.type === 'node' && selected.id === nodeId;
            const selectedLink = getSelectedLinkForNode(selected, nodeId, links);
            const hoveredLink = getSelectedLinkForNode(hovered, nodeId, links);
            return (React.createElement(NodeWrapper, Object.assign({ config: config, key: nodeId, Component: Node, node: nodes[nodeId], offset: chart.offset, isSelected: isSelected, selected: selectedLink ? selected : undefined, hovered: hoveredLink ? hovered : undefined, selectedLink: selectedLink, hoveredLink: hoveredLink, NodeInner: NodeInner, Ports: Ports, Port: Port }, nodeCallbacks, portCallbacks)));
        })));
};
const getSelectedLinkForNode = (selected, nodeId, links) => {
    const link = selected.type === 'link' && selected.id ? links[selected.id] : undefined;
    if (link && (link.from.nodeId === nodeId || link.to.nodeId === nodeId)) {
        return link;
    }
    return undefined;
};
